import type {
  tAmountDueToday,
  tSeatQuote,
} from 'src/providers/SubscriptionProvider/useSeatPurchase.types';

/**
 * How money moves for this seat. Each arm says something different to the customer,
 * and getting it wrong is a promise the invoice will not keep.
 */
export enum eSeatBillingMode {
  UNKNOWN = 'UNKNOWN',
  /** A card is charged; the preview says how much lands today. */
  CARD = 'CARD',
  /** Nothing is charged now; billing lands at trial end for the total seat count. */
  TRIALING = 'TRIALING',
  /**
   * `send_invoice` terms: a SEPARATE invoice is issued immediately, due in three
   * days. It does not wait for the next renewal, and no card is ever requested.
   */
  INVOICE = 'INVOICE',
}

export type tSeatCostNoticeProps = {
  quote: tSeatQuote;
  amountDueToday: tAmountDueToday;
  isLoadingAmountDueToday: boolean;
  billingMode: eSeatBillingMode;
  /** Sends the customer to the Subscription tab when no price resolves (R16). */
  onGoToSubscription: () => void;
};
